import { env } from './env'

export const WEBAPP_V2_URL = `https://${env.WEBAPP_V2_DOMAIN}`
